import React from 'react'
import { useState } from 'react'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeInventoryNumberForm from './ChangeInventoryNumberForm'

const ChangeInventoryNumberButton = ({ writeOffActItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={writeOffActItem.inventoryNumber}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
            positionIco='left'
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування інвентарного номера'}
            disableClickOutside={true}
            content={
                <ChangeInventoryNumberForm
                    writeOffActItemBd={writeOffActItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeInventoryNumberButton